// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import moment from "moment";
// import Layouts from "../../layouts/layouts";
// import DataTable from "react-data-table-component";

// export default function PayoutHistory() {
//   const { id } = useParams();
//   const [history, setHistory] = useState([]);
//   const [fromDate, setFromDate] = useState(null);
//   const [toDate, setToDate] = useState(null);

//   const fetchHistory = async (from, to) => {
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         console.error("No token found");
//         return;
//       }

//       const params = {
//         clientId: id,
//       };

//       if (from) params.from = moment(from).format("YYYY-MM-DD");
//       if (to) params.to = moment(to).format("YYYY-MM-DD");

//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/api/v2/payout-histories`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           params,
//         }
//       );

//       const data = response.data || [];
//       setHistory(data);
//     } catch (error) {
//       console.error("Error fetching payout history: ", error);
//       setHistory([]);
//     }
//   };

//   useEffect(() => {
//     fetchHistory(fromDate, toDate);
//   }, [id, fromDate, toDate]);

//   const columns = [
//     {
//       name: <b>Date</b>,
//       selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
//       sortable: true,
//     },
//     {
//       name: <b>Vehicle Type</b>,
//       selector: (row) => row.vehicleType || "N/A",
//       sortable: true,
//     },
//     {
//       name: <b>Picked (Old → New)</b>,
//       selector: (row) =>
//         `${row.previousPayout?.orderPicked} → ${row.newPayout?.orderPicked}`,
//       sortable: true,
//     },
//     {
//       name: <b>Delivered (Old → New)</b>,
//       selector: (row) =>
//         `${row.previousPayout?.orderDelivered} → ${row.newPayout?.orderDelivered}`,
//       sortable: true,
//     },
//     {
//       name: <b>Updated At</b>,
//       selector: (row) => moment(row.updatedAt).format("DD-MM-YYYY HH:mm"),
//       sortable: true,
//     },
//   ];

//   return (
//     <>
//       <Layouts />
//       <div className="container-fluid">
//         <div className="row my-3">
//           <div className="col-12">
//             <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
//               <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1">
//                 <div>Payout History</div>
//                 <div className="d-flex align-items-center">
//                   <div className="me-3">
//                     <label>From Date:</label>
//                     <input
//                       type="date"
//                       value={
//                         fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""
//                       }
//                       onChange={(e) => setFromDate(e.target.value)}
//                       className="form-control"
//                       style={{ width: "150px" }}
//                     />
//                   </div>
//                   <div>
//                     <label>To Date:</label>
//                     <input
//                       type="date"
//                       value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
//                       onChange={(e) => setToDate(e.target.value)}
//                       className="form-control"
//                       style={{ width: "150px" }}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="card-body">
//                 <DataTable
//                   columns={columns}
//                   data={history}
//                   pagination
//                   fixedHeader
//                   highlightOnHover
//                   responsive
//                   paginationPerPage={5}
//                   paginationRowsPerPageOptions={[5, 10, 15, 20]}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Layouts from "../../layouts/layouts";
import DataTable from "react-data-table-component";

export default function PayoutHistory() {
  const { hubId } = useParams(); // Extract hubId from URL parameters
  const [history, setHistory] = useState([]);

  const fetchHistory = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v2/payout-history/fetch`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            hubId: hubId,
          },
        },
      );

      const data = response.data.payoutHistory || [];
      setHistory(data);
    } catch (error) {
      console.error("Error fetching payout history: ", error);
      setHistory([]);
    }
  };

  //   const fetchHistory = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       if (!token) {
  //         console.error("No token found");
  //         return;
  //       }

  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BASE_URL}/api/v2/payout-history/fetch`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //           params: {
  //             hubId: hubId, // Ensure hubId is a string
  //           },
  //         }
  //       );

  //       const data = response.data.payoutHistory
  //         ? [response.data.payoutHistory]
  //         : [];
  //       setHistory(data);
  //     } catch (error) {
  //       console.error("Error fetching payout history: ", error);
  //       setHistory([]);
  //     }
  //   };

  useEffect(() => {
    fetchHistory();
  }, [hubId]);

  const columns = [
    {
      name: <b>Date</b>,
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: <b>Company</b>,
      selector: (row) => (row.companyId ? row.companyId.company : "-"),
      sortable: true,
    },
    {
      name: <b>Vehicle Type</b>,
      selector: (row) => row.vehicleType || "N/A",
      sortable: true,
    },
    {
      name: <b>Payout Days</b>,
      selector: (row) => row.payoutDays || "N/A",
      sortable: true,
    },
    {
      name: <b>Picked (Old → New)</b>,
      selector: (row) =>
        `${row.previousPayout?.orderPicked} → ${row.newPayout?.orderPicked}`,
      sortable: true,
    },
    {
      name: <b>Delivered (Old → New)</b>,
      selector: (row) =>
        `${row.previousPayout?.orderDelivered} → ${row.newPayout?.orderDelivered}`,
      sortable: true,
    },
    {
      name: <b>Trips (Old → New)</b>,
      selector: (row) =>
        `${row.previousPayout?.trips} → ${row.newPayout?.trips}`,
      sortable: true,
    },
  ];

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1">
                <div>Payout History</div>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={history}
                  pagination
                  fixedHeader
                  highlightOnHover
                  responsive
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
